import * as React from "react";
import { BrowserRouter, Route, Link, Switch, Redirect } from "react-router-dom";
import { AdminHomePageModel } from '../../models/homePage/adminHomePageModel';
import HomePageService from '../../services/homePageService';

interface IProps {
}

interface IState {
  adminHomePage: AdminHomePageModel;
  isLoading: boolean;
  error: any;
  validationMessage: string;
}

class HomePageComponent extends React.Component<IProps, IState> {
  homePageService = new HomePageService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      validationMessage: '',
      adminHomePage: new AdminHomePageModel(),
      isLoading: false,
    };
  }

  componentDidMount() {
    this.getHomePageCounts();
  }

  getHomePageCounts() {
    this.setState({
      isLoading: true
    });

    this.homePageService.getHomePageCounts().then(
      (data: AdminHomePageModel) => {
        this.setState({
          isLoading: false,
          adminHomePage: data
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  render() {
    const { adminHomePage } = this.state;

    return (
      <div>
        <h3>MedXchange Administration</h3>
        <div className="p-grid p-fluid dashboard">
          <div className="p-col-12 p-lg-3">
            <Link to="/medicines">
              <div className="card summary">
                <span className="title">Medicines</span>
                <span className="detail">Number of medicines</span>
                <span className="count medicines">{adminHomePage.medicinesCount}</span>
              </div>
            </Link>
          </div>
          <div className="p-col-12 p-lg-3">
            <Link to="/active-ingredients">
              <div className="card summary">
                <span className="title">Active ingredients</span>
                <span className="detail">Number of active ingredients</span>
                <span className="count active-ingredients">{adminHomePage.activeIngredientsCount}</span>
              </div>
            </Link>
          </div>
          <div className="p-col-12 p-lg-3">
            <Link to="/configuration/inactive-ingredients">
              <div className="card summary">
                <span className="title">Inactive ingredients</span>
                <span className="detail">Number of Inactive ingredients</span>
                <span className="count users">{adminHomePage.inactiveIngredientsCount}</span>
              </div>
            </Link>
          </div>
          <div className="p-col-12 p-lg-3">
            <Link to="/configuration/atc-codes">
              <div className="card summary">
                <span className="title">ATC Codes</span>
                <span className="detail">Number of ATC Codes</span>
                <span className="count addtional">{adminHomePage.atcCodesCount}</span>
              </div>
            </Link>
          </div>
          <div className="p-col-12 p-lg-3">
            <Link to="/configuration/manufacturers">
              <div className="card summary">
                <span className="title">Manufacturers</span>
                <span className="detail">Number of manufacturers</span>
                <span className="count manufacturers">{adminHomePage.manufacturersCount}</span>
              </div>
            </Link>
          </div>
          <div className="p-col-12 p-lg-3">
            <Link to="/configuration/foodAlcohols">
              <div className="card summary">
                <span className="title">Foods and Alcohols</span>
                <span className="detail">Number of Foods and Alcohols</span>
                <span className="count foods">{adminHomePage.foodAndAlcoholCount}</span>
              </div>
            </Link>
          </div>
          <div className="p-col-12 p-lg-3">
            <Link to="/configuration/diseases">
              <div className="card summary">
                <span className="title">Diseases</span>
                <span className="detail">Number of Diseases</span>
                <span className="count diseases">{adminHomePage.diseasesCount}</span>
              </div>
            </Link>
          </div>
          <div className="p-col-12 p-lg-3">
            <Link to="/configuration/anatomical-systems">
              <div className="card summary">
                <span className="title">Anatomical systems</span>
                <span className="detail">Number of Anatomical systems</span>
                <span className="count anatomical">{adminHomePage.anatomicalSystemsCount}</span>
              </div>
            </Link>
          </div>
        </div>
      </div >
    )
  }
}

export default HomePageComponent;